import { Injectable } from '@angular/core';
import { ExecutionResult, LcsApiService } from '@lcs/shared/api';
import { PhoneNumberInput } from 'generated/graphql-types';
import { Observable } from 'rxjs';
import { PhoneNumberDetailSaveModel } from '../../phone-number-details/models/phone-number-detail-save.model';
import {
   SavePhoneNumber,
   SavePhoneNumberVariables,
} from '../../phone-number-details/queries/generated/SavePhoneNumber';
import { SavePhoneNumberMutation } from '../../phone-number-details/queries/save-phone-number.graphql';

@Injectable({ providedIn: 'root' })
export class AddPhoneNumberApiService {
   constructor(private apiService: LcsApiService) {}

   create(phoneNumberDetail: PhoneNumberDetailSaveModel): Observable<ExecutionResult<SavePhoneNumber>> {
      const fields: (keyof PhoneNumberInput)[] = [
         'phoneNumber',
         'providerId',
         'isPorted',
         'datePorted',
         'accountId',
         'isActive',
         'openExtensionId',
         'closedExtensionId',
      ];
      return this.apiService.query<SavePhoneNumber, SavePhoneNumberVariables>({
         query: SavePhoneNumberMutation,
         variables: {
            phoneNumber: {
               ...phoneNumberDetail,
               fields: fields,
            },
         },
      });
   }
}
